export enum DashboardMobileTabs {
  MyPapers = "myPapers",
  OtherPapers = "otherPapers",
  MyExams = "myExams",
}
